// extracted by mini-css-extract-plugin
export default {"handoff":"LiveHandoff_handoff__b692b","opening":"LiveHandoff_opening__xRB4L","openingOut":"LiveHandoff_openingOut__aHQRr"};